import { useQuery } from 'react-query';
import { QueryKey } from 'src/config/queryKey';
import { getCourseById } from 'src/common/services/course';
import { courseQueryStaleTime } from 'src/config/cache';
import { useCurrentUserKeyEnhancer } from 'src/common/hooks/useCurrentUserKeyEnhancer';
import { Course } from 'src/common/models/course';

export function useCourseQuery(id?: number, initialData?: () => Course | undefined) {
  const { key } = useCurrentUserKeyEnhancer([QueryKey.Course, id]);

  return useQuery(key, () => (id ? getCourseById(id) : undefined), {
    staleTime: courseQueryStaleTime,
    enabled: !!id,
    initialData,
  });
}
